// backend statuses
export const WORKPACK_BACKEND_STATUS = Object.freeze({
    NEW: 'NEW',
    GENERATING_PRINT_SPEC: 'GENERATING_PRINT_SPEC',
    GENERATING_PDF: 'GENERATING_PDF',
    AVAILABLE: 'AVAILABLE',
    FAILED: 'FAILED',
    EXPIRED: 'EXPIRED'
});

// ui labels
export const WORKPACK_DISPLAY_STATUS = Object.freeze({
    CREATING: 'CREATING',
    NEW_TODAY: 'NEW_TODAY',
    AVAILABLE: 'AVAILABLE',
    AVAILABLE_DAYS_LEFT: 'AVAILABLE_DAYS_LEFT',
    EXPIRED: 'EXPIRED',
    FAILED: 'FAILED'
});

// Statuses that should keep polling
export const POLLING_BACKEND_STATUSES = Object.freeze(new Set([
    WORKPACK_BACKEND_STATUS.NEW,
    WORKPACK_BACKEND_STATUS.GENERATING_PRINT_SPEC,
    WORKPACK_BACKEND_STATUS.GENERATING_PDF
]));

// backend status to display status mapping
export const BE_TO_FE_STATUS_MAP = Object.freeze({
    [WORKPACK_BACKEND_STATUS.NEW]: WORKPACK_DISPLAY_STATUS.CREATING,
    [WORKPACK_BACKEND_STATUS.GENERATING_PRINT_SPEC]: WORKPACK_DISPLAY_STATUS.CREATING,
    [WORKPACK_BACKEND_STATUS.GENERATING_PDF]: WORKPACK_DISPLAY_STATUS.CREATING,
    [WORKPACK_BACKEND_STATUS.AVAILABLE]: WORKPACK_DISPLAY_STATUS.AVAILABLE,
    [WORKPACK_BACKEND_STATUS.FAILED]: WORKPACK_DISPLAY_STATUS.FAILED,
    [WORKPACK_BACKEND_STATUS.EXPIRED]: WORKPACK_DISPLAY_STATUS.EXPIRED
});

const WORKPACK_DISPLAY_ID_MAP = Object.freeze({
    [WORKPACK_DISPLAY_STATUS.CREATING]: 'listWorkpackPage.statusCreating',
    [WORKPACK_DISPLAY_STATUS.NEW_TODAY]: 'listWorkpackPage.newToday',
    [WORKPACK_DISPLAY_STATUS.AVAILABLE]: 'listWorkpackPage.packAvailable',
    [WORKPACK_DISPLAY_STATUS.AVAILABLE_DAYS_LEFT]: 'listWorkpackPage.packAvailable',
    [WORKPACK_DISPLAY_STATUS.EXPIRED]: 'listWorkpackPage.expired',
    [WORKPACK_DISPLAY_STATUS.FAILED]: 'listWorkpackPage.statusFailed'
});

/**
 *
 * @param {keyof WORKPACK_DISPLAY_STATUS} status
 * @returns
 */
export const getStatusId = (status) => {
    return WORKPACK_DISPLAY_ID_MAP[status] || WORKPACK_DISPLAY_ID_MAP[WORKPACK_DISPLAY_STATUS.EXPIRED];
};

export const getStatusClass = (statusLabel) => {
    switch (statusLabel) {
        case WORKPACK_DISPLAY_STATUS.CREATING:
            return 'govuk-tag govuk-tag--yellow';
        case WORKPACK_DISPLAY_STATUS.NEW_TODAY:
            return 'govuk-tag govuk-tag--blue';
        case WORKPACK_DISPLAY_STATUS.AVAILABLE_DAYS_LEFT:
        case WORKPACK_DISPLAY_STATUS.AVAILABLE:
            return 'govuk-tag govuk-tag--green';
        case WORKPACK_DISPLAY_STATUS.EXPIRED:
            return 'govuk-tag govuk-tag--grey';
        case WORKPACK_DISPLAY_STATUS.FAILED:
            return 'govuk-tag govuk-tag--red';
        default:
            return 'govuk-tag govuk-tag--grey';
    }
};
